import { useParams } from 'react-router-dom';

import { CompanyShell } from '@/components/company-shell';
import { useRecentCompanies } from '@/services/recent-companies';

/**
 * Page `/company/:companyId/*` — wraps all the company-scoped tabs (Empresa,
 * Plan, Paquete, Crédito) with `CompanyShell`. The shell fetches the
 * company once, mounts the sticky banner and exposes the company via outlet
 * context. This page also feeds `rememberCompany` so the lookup hits the
 * RECIENTES card on the search page.
 */
export const CompanyShellPage = () => {
  const { companyId } = useParams();
  const { remember } = useRecentCompanies();

  if (!companyId) {
    return null;
  }

  return <CompanyShell companyId={companyId} onCompanyLoaded={remember} />;
};
